import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RadioGroupSettings } from "../../shared/models/radioGroup.model";
import { HelperService } from "../../shared/services/helper/helper.service";

@Component({
  selector: '[app-cea-radio-group-bootstrap]',
  standalone: false,
  templateUrl: './cea-radio-group-bootstrap.component.html',
  styleUrl: './cea-radio-group-bootstrap.component.scss'
})
export class CeaRadioGroupBootstrapComponent implements OnInit {

  @Input() radioGroupSettings: RadioGroupSettings;
  bindModel: boolean;
  @Output() setRadioValue = new EventEmitter<any>();
  groupkey = this.helper.GenerateGuid();

  constructor(
    private translate: TranslateService,
    private helper: HelperService
  ){}

    ngOnInit(): void {
        this.bindModel = this.radioGroupSettings.bindModel;
    }

    radioValueChanged() {
        this.setRadioValue.emit({ key: this.radioGroupSettings.radioKey, value: this.bindModel });
    }

  isMobileDevice() : boolean {
    return window.innerWidth <= 544;
  }
}
